var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 27,
    viewBox: "0 0 44 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5569 0.522734C33.5565 0.157001 26.5624 3.5976 20.1191 8.34311C17.857 10.0724 16.9043 11.4947 16.9043 13.066C16.9043 14.082 17.3242 15.0031 17.997 15.6623C18.2634 15.9558 19.1935 16.7866 19.6676 17.1884C27.1087 23.4782 33.1907 28.025 38.7761 26.0293C43.5306 24.3315 43.5125 18.2856 43.517 13.066C43.5351 1.34451 40.4196 0.784617 37.5569 0.522734Z",
    fill: "#E8AB7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96014 0.522734C9.95612 0.157001 16.9547 3.5976 23.398 8.34311C25.6601 10.0724 26.6128 11.4947 26.6128 13.066C26.6128 14.082 26.1929 15.0031 25.5201 15.6623C25.2537 15.9558 24.3236 16.7866 23.8495 17.1884C16.4084 23.4782 10.3219 28.025 4.74103 26.0293C-0.0135016 24.3315 0.00455924 18.2856 4.40139e-05 13.066C-0.0135017 1.34451 3.10201 0.784617 5.96014 0.522734Z",
    fill: "#85CBC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9043 13.0656C16.9043 14.0815 17.3242 15.0026 17.997 15.6618C18.2634 15.9553 19.1935 16.7861 19.6721 17.188C20.381 17.7885 21.0764 18.371 21.7582 18.9309C22.4445 18.3665 23.1398 17.784 23.8442 17.188C24.3228 16.7861 25.253 15.9553 25.5194 15.6618C26.1921 15.0026 26.612 14.086 26.612 13.0656C26.612 11.4943 25.6548 10.072 23.3972 8.34266C22.8554 7.94081 22.3045 7.55701 21.7582 7.17773C21.2073 7.55701 20.661 7.94532 20.1191 8.34266C17.8615 10.072 16.9043 11.4943 16.9043 13.0656Z",
    fill: "#752133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyteIcon);
export default __webpack_public_path__ + "static/media/syteIcon.cecc4e70f873d9925719c720264f55f3.svg";
export { ForwardRef as ReactComponent };